import './product-list.scss';

export default async () => {
	let btn = $( '.woocommerce-pagination .next' );
	let blog = '.js-product-list__item';
	let delay = 1000;

	btn.text( 'Load More' );

	function recall ( btn, delay, blog ) {
		btn.on( 'click', function ( e ) {
			e.preventDefault();

			let nextPage = btn.attr( 'href' );
			let retrievedData = $( '<div id="articles2" style="display: none">' ).load( `${nextPage} ${blog}` );

			btn.parent().load( `${nextPage} .next` );
			$( '#articles' ).append( retrievedData );

			setTimeout( () => {
				const articleNew = document.getElementById( 'articles2' );

				articleNew.replaceWith( ...articleNew.childNodes );
			}, delay );

			setTimeout( () => {
				let btn = $( '.woocommerce-pagination .next' );

				btn.text( 'Load More' );
				recall( btn, delay, blog );
			}, delay );
		} );
	}

	recall( btn, delay, blog );
};
